import React, { createContext, useContext, useState, ReactNode } from "react";

interface RoasData {
  budget: number;
  roas: number;
  aov: number;
  hasCalculated: boolean;
}

interface RoasContextType {
  roasData: RoasData;
  updateRoasData: (data: Partial<RoasData>) => void;
}

const RoasContext = createContext<RoasContextType | undefined>(undefined);

export function RoasProvider({ children }: { children: ReactNode }) {
  const [roasData, setRoasData] = useState<RoasData>({
    budget: 50000,
    roas: 4.0,
    aov: 1500,
    hasCalculated: false,
  });

  const updateRoasData = (data: Partial<RoasData>) => {
    setRoasData((prev) => ({
      ...prev,
      ...data,
    }));
  };

  return (
    <RoasContext.Provider value={{ roasData, updateRoasData }}>
      {children}
    </RoasContext.Provider>
  );
}

export function useRoas() {
  const context = useContext(RoasContext);
  if (!context) {
    throw new Error("useRoas must be used within a RoasProvider");
  }
  return context;
}
